import { createContext } from 'react';

export const fallbackAuthState = {
  isAuthenticated: false,
  isLoading: false,
  identityUser: null,
  userRoles: [],
  userPermissions: [],
  isAdmin: false,
  isAgent: false,
  needsProfileCompletion: false,
  loginWithRedirect: () => {},
  logout: () => {},
  getToken: async () => null,
  getTokenOrThrow: async () => {
    throw new Error('Account is not authenticated');
  },
  validateToken: async () => ({ isValid: false }),
  isValidatingToken: false,
  authLifecycleState: 'booting',
  authResolved: false,
  authReadyForProtectedRoutes: false,
  authTransitionCount: 0,
  authBootstrapDurationMs: null,
  tokenAcquisitionCount: 0,
  profileSyncCount: 0,
  authError: null,
  sessionExpired: false,
  showExpiryWarning: false,
  timeUntilExpiry: null,
};

export const AuthStateContext = createContext(fallbackAuthState);
